/*
 * Copyright (c) 2021 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import { Helmet } from "react-helmet";
import { googleTagManagerId } from "../../const/env";

const script = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${googleTagManagerId}', { 'anonymize_ip': true });`;

export const GoogleTagManagerInit = () =>
  (googleTagManagerId !== "" && (
    <Helmet>
      <link
        rel="stylesheet"
        id="klaro-css"
        href="https://www.starbreeze.com/wp-content/themes/brando-child/klaro/klaro.css"
        type="text/css"
        media="all"
      />
      <link
        rel="stylesheet"
        id="klaro-custom-css"
        href="https://www.starbreeze.com/wp-content/themes/brando-child/klaro/klaro-custom.css"
        type="text/css"
        media="all"
      />
      <link
        rel="stylesheet"
        id="klaro-custom-css"
        href="https://www.starbreeze.com/wp-content/themes/brando-child/klaro/klaro-custom-accounts.css"
        type="text/css"
        media="all"
      />
      <script
        type="text/javascript"
        src="https://www.starbreeze.com/wp-content/themes/brando-child/klaro/klaro-config.js"
        id="klaro-config-js"
      ></script>
      <script
        type="text/javascript"
        src="https://www.starbreeze.com/wp-content/themes/brando-child/klaro/klaro.js"
        id="klaro-js"
      ></script>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${googleTagManagerId}`}></script>
      <script>{script}</script>
    </Helmet>
  )) ||
  null;
